/**
 * Turning a status code into a sentence a person can act on.
 */

export function problem(status: number, attempt: string): string {
  if (status === 401) return "Your session ended. Sign in again to continue.";
  if (status === 403) return `You do not have permission to ${attempt}.`;
  if (status === 404)
    return `We could not find what you asked for when trying to ${attempt}.`;
  // 502 is what the API answers when a service it relies on (the AI model, the
  // answer provider) failed. Saying "we broke" sent people looking for our bug
  // on the day the model key had simply expired.
  if (status === 502)
    return `A service Crux relies on did not answer, so we could not ${attempt}. Try again in a few minutes.`;
  if (status >= 500) return `Something on our side broke while trying to ${attempt}.`;
  return `Could not ${attempt} (${String(status)}).`;
}
